import { Select } from '@automata/ui';
import { FormControl, MenuItem, Stack, Typography } from '@mui/material';
import React from 'react';

import { ParameterType } from './types';
import { allParameterTypes, getParameterIcon } from './utils';

interface TypeSelectProps {
  disabled?: boolean;
  label: string;
  typeOptions: ParameterType[];
  value: ParameterType | null;
  onChange: (value: ParameterType) => void;
}

export const TypeSelect = ({
  disabled,
  label,
  typeOptions,
  value,
  onChange,
}: TypeSelectProps) => {
  return (
    <FormControl fullWidth>
      <Select
        disabled={disabled}
        label={label}
        value={value ?? ''}
        onChange={(e) => {
          const value = e.target.value;
          if (allParameterTypes.includes(value as ParameterType)) {
            onChange(value as ParameterType);
          }
        }}
      >
        {typeOptions.map((type) => (
          <MenuItem key={type} value={type}>
            <Stack direction="row" alignItems="center">
              {getParameterIcon(type)}
              <Typography marginLeft={1} variant="body2">
                {type}
              </Typography>
            </Stack>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
